<template>
  <div id="app">
    <el-menu :default-active="activeIndex" mode="horizontal" router>
      <el-menu-item index="top_" :route="{ name:'route_top' }">Top</el-menu-item>
      <el-menu-item index="curiosity_" :route="{ name:'route_curiosity' }">Curiosity</el-menu-item>
      <el-menu-item index="opportunity_" :route="{ name:'route_opportunity' }">Opportunity</el-menu-item>
      <el-menu-item index="spirit_" :route="{ name:'route_spirit' }">Spirit</el-menu-item>
      <el-menu-item>
        <a href="https://forestofpapers.azurewebsites.net/" target="_blank">Link</a>
      </el-menu-item>
    </el-menu>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      activeIndex: this.$route.name
    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
a {
  text-decoration: none;
}
</style>
